/**
 * TODO: KILL THIS FILE. It's Baaaaaaad
 */
var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

if (typeof $.swPortal === 'undefined') {
  $.swPortal = {};
}


/**
 * MARKETPLACE & SEARCH PAGES
 * This is only called on the marketplace and search page
 * TODO: make lazy loaded autohandler
 */
function searchResultsRefresh() {
  if ($('#searchFacetsForm').length) {
    $('#searchFacetsForm').submit();
  }
}

function formatDollar($val, $includeCents, $includeDollarSymbol) {
  var $valFloat = parseFloat($val);
  if (isNaN($valFloat)) {
    return $val;
  }

  var $valParts = $valFloat.toFixed(2).split(".");

  var $dollarAmount = '';
  var j = 0;
  for (var i = $valParts[0].length - 1; i >= 0; i--) {
    $dollarAmount = $valParts[0].charAt(i) + $dollarAmount;
    if (++j === 3 && i > 0) {
      $dollarAmount = ',' + $dollarAmount;
      j = 0;
    }
  }

  return ($includeDollarSymbol ? '$' : '') + $dollarAmount + ($includeCents ? '.' + $valParts[1] : '');
}

function scriptifyFacets() {
  var priceRefreshResultsTimeout = null;
  var $priceSpan = $('#priceRangeFacetSpan');

  if ($priceSpan.length) {
    var $priceRange = {
      min:$('#facetPriceMin').val(),
      max:$('#facetPriceMax').val(),
      from:$('#facetPriceFrom').val(),
      to:$('#facetPriceTo').val()
    };

    if (!$priceRange.from) {
      $priceRange.from = $priceRange.min;
    }
    if (!$priceRange.to) {
      $priceRange.to = $priceRange.to = $priceRange.max;
    }

    // no negatives...
    for (var i in $priceRange) {
      $priceRange[i] = Math.max($priceRange[i], 0);
    }

    $priceRange.range = $priceRange.max - $priceRange.min;
    $priceRange.step = Math.round($priceRange.range / 100);


    $priceSpan.hide();

    var $priceSlider = $('#priceRangeFacetSlider .ui-slider').swSlider({
      min:$priceRange.min,
      max:$priceRange.max,
      range:true,
      step:1,
      values:[$priceRange.from, $priceRange.to]
    });

    $priceSlider.bind("slidestart slide slidestop slidechange", function () {
      //values not changed before the slide event is called, give it a timeout
      setTimeout(function () {
        var maxPriceUsed = '';
        var values = $priceSlider.swSlider("values");
        if (values[1] >= 2500) {
          maxPriceUsed = '+';
        }
        $('#selectedPriceRangeLabel').text(formatDollar(values[0], false, true) + ' - ' + formatDollar(values[1], false, true) + maxPriceUsed);
      }, 50);
    });

    $priceSlider.bind("slidestart", function () {
      //make sure we don't refresh the page..
      if (priceRefreshResultsTimeout) {
        clearTimeout(priceRefreshResultsTimeout);
        priceRefreshResultsTimeout = null;
      }
    });

    $priceSlider.bind("slidestop slidechange", function () {
      // set the values to the input fields..
      var values = $priceSlider.swSlider("values");
      $('#facetPriceFrom').val(values[0]);
      $('#facetPriceTo').val(values[1]);

      //refresh results after small timeout in case the user wants to change the other price handle
      if (!priceRefreshResultsTimeout) {
        priceRefreshResultsTimeout = setTimeout(searchResultsRefresh, 2000);
      }
    });
  }

  $('#facetIsCustomizable, #facetIsMature').change(function () {
    searchResultsRefresh();
  });

  $('#facetUpdateButton').remove();
}


function scriptifySortOptions() {
  var $sortOptions = $('#searchResultsSortOptions');
  if ($sortOptions.length) {
    $sortOptions.change(function () {
      $(this).closest('form').submit();
    });
    $sortOptions.next('input').remove();
  }
}

// search results page stuff
scriptifyFacets();
scriptifySortOptions();
/**
 * END
 * MARKETPLACE & SEARCH PAGES
 */



/* /Generic functions */
$('body').promise('shapeways-ready').then(function() {

  /*
    TODO: Check decide with UX if this is still necessary
    checkbox-wrap focus animation
  */
  $('.checkbox-wrap input, .checkbox-wrapper input, .input-group input').focus(function() {
    $(this).parent().addClass('focus');
  });
  $('.checkbox-wrap input, .checkbox-wrapper input, .input-group input').blur(function() {
    $(this).parent().removeClass('focus');
  });

  $.swPortal.addToCartPopup = function ($href, $params) {
    $.swAjax({
      timeout: $.swAjax.SW_TIMEOUT_TIME,
      url: $href,
      data: $params,
      retryTimeout: function retryTimeout(jqXHR, textStatus, errorThrown, swInfo) {
        $.swAjax.triggerDefaultRetryNotey(swInfo.retryEventID);
      },
      error: function error(jqXHR, textStatus) {
        if(textStatus !== $.swAjax.ERROR_TYPES.TIMEOUT) {
          $.swAjax.triggerDefaultFailNotey();
        }
      },
      success: function(html){
        if(html){
            sw.trigger('cart-add-product', '');
        }
      }
    });
  };
});
